// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qp42K","col":"styles_col__245z8"};